import * as actions from '../actions/index';

const Immutable = require('immutable');

// 导航排序，null 需要放在最后面
function compareNavMenu(a, b) {
  if (a.sortNo === null) {
    return 1;
  }
  if (a.sortNo !== null && b.sortNo === null) {
    return -1;
  }
  if (a.sortNo < b.sortNo) {
    return -1;
  }
  if (a.sortNo > b.sortNo) {
    return 1;
  }
  return 0;
}

// 规范导航数据
function formatNavMenuData(data) {
  for (let value of data) {
    value['name'] = value.menuName;
    value['nameEn'] = value.menuName;
    value['dataIndex'] = value.id;
  }
}

export default {
  [actions.getUserInfoAction]: (state, data) => {
    // 是否平台侧用户
    let systemTenantid,
      userInfo = data;
    if (userInfo.roles && userInfo.roles.length) {
      for (let role of userInfo.roles) {
        if (role.roleCode === 'platformAdmin') {
          systemTenantid = role.tenantid;
          break;
        }
      }
    }

    systemTenantid && (data.systemTenantid = systemTenantid);
    return state.set('user', Immutable.fromJS(data));
  },
  [actions.getTenantInfoAction]: (state, data) => {
    return state.set('tenant', Immutable.fromJS(data));
  },
  [actions.getSiteTypeAction]: (state, data) => {
    return state.set('siteType', Immutable.fromJS(data));
  },
  [actions.getNavMenuAction]: (state, data) => {
    const _data = data.data;
    formatNavMenuData(_data);
    return state.set(
      'navMenuData',
      Immutable.fromJS(
        _data
          .filter(
            item =>
              (item.parentResId === '0' || item.parentResId === null)
          )
          .sort(compareNavMenu)
      )
    );
  },
  [actions.getLicenseAction]: (state, data) =>
    state.set('licenseBrands', Immutable.fromJS(data)),
  [actions.getReady]: (state) => {
    return state.set('ready', true)
  },
  [actions.getUserReady]: (state) => {
    return state.set('userReady', true)
  },
  [actions.getSiteReady]: (state) => {
    return state.set('siteReady', true)
  },
  [actions.getSearchKey]: (state, data) => {
    return state.set('searchKeyWord', Immutable.fromJS(data))
  },
  [actions.isv]: (state, data) => {
    return state.set('isv', Immutable.fromJS(data))
  },
  [actions.successOpen]: (state, data) => {
    return state.set('successOpen', Immutable.fromJS(data))
  },
  [actions.okFlag]: (state, data) => {
    return state.set('okFlag', Immutable.fromJS(data))
  },
  [actions.cancleFlag]: (state, data) => {
    return state.set('cancleFlag', Immutable.fromJS(data))
  },
  [actions.routeFlag]: (state, data) => {
    return state.set('routeFlag', Immutable.fromJS(data))
  },
  [actions.changeRouter]: (state, data) => {
    return state.set('changeRouter', Immutable.fromJS(data))
  },
  [actions.searchFlag]: (state, data) => {
    return state.set('searchFlag', Immutable.fromJS(data))
  },
  /**
   *  微评估相关state
   */
  // 设置微评估数据
  [actions.setAppData]: (state, data) => {
    return state.set('appData', Immutable.fromJS(data))
  },
  //  通知中心
  [actions.confirmNewsIndex]: (state, data) => {
    return state.set('confirmNewsIndex', Immutable.fromJS(data))
  },
  [actions.confirmNewsNumber]: (state, data) => {
    return state.set('confirmNewsNumber', Immutable.fromJS(data))
  },
  [actions.setWhiteList]: (state,data) =>{
    return state.set('whiteList',Immutable.fromJS(data));
  },
  [actions.setAppInfo]: (state,data) =>{
    return state.set('appInfo',Immutable.fromJS(data));
  },
  [actions.setRoleType]: (state,data) =>{
    return state.set('roleType',Immutable.fromJS(data));
  },
  [actions.appBaseInfo]: (state,data) =>{
    return state.set('appBaseInfo',Immutable.fromJS(data));
  },
  [actions.abilityMenuList]: (state,data) =>{
    return state.set('abilityMenuList',Immutable.fromJS(data));
  }
};
